import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=791a45f8&scoped=true&"
var script = {}
import style0 from "./operation.vue?vue&type=style&index=0&id=791a45f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a45f8",
  null
  
)

export default component.exports